import { create } from 'zustand';
import type { ActionButtonsVisibility } from './types';

interface AccountActionsAvailabilityState {
  deposit: boolean;
  withdraw: boolean;
  transfer: boolean;
  setAccountActionsAvailability: (visibility: ActionButtonsVisibility) => void;
}

const useAccountActionsAvailability = create<AccountActionsAvailabilityState>(
  set => ({
    deposit: false,
    withdraw: false,
    transfer: false,
    setAccountActionsAvailability: (visibility: ActionButtonsVisibility) =>
      set(visibility),
  })
);

export { useAccountActionsAvailability };
